var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Client, Message } from 'paho-mqtt';
import { Subject } from 'rxjs';
import { MessageWrapper } from '.';
const isNode = () => Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
// Only Node.JS has a process variable that is of [[Class]] process
if (isNode()) {
    const ws = require('ws');
    global.WebSocket = ws;
}
export class MqttAsyncApi {
    constructor(url, targetId, topics) {
        this._topics = [];
        this._channelAlias = {};
        this.name = typeof this;
        this.inbox = new Subject();
        let resolve;
        let reject;
        this.connected = new Promise((r, j) => {
            resolve = r;
            reject = j;
        });
        this._topics = topics;
        this._client = new Client(url, targetId);
        this._client.connect({
            useSSL: true,
            timeout: 3,
            mqttVersion: 4,
            onSuccess: () => {
                this._topics.map(topic => this._client.subscribe(topic));
                resolve(true);
            },
            onFailure: (error) => {
                console.log(error);
                reject(error);
            },
        });
        this._client.onMessageArrived = (mqttMsg) => {
            const msg = this.toMessageWrapper(mqttMsg);
            if (msg)
                this.inbox.next(msg);
        };
    }
    disconnect() {
        this._client.disconnect();
        this.connected = Promise.resolve(false);
    }
    send(ceMsg) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const msg = new Message(JSON.stringify(ceMsg));
            const targetId = (_a = ceMsg.data) === null || _a === void 0 ? void 0 : _a.metadata.targetId;
            msg.destinationName = targetId ? targetId : this._topics[0];
            this._client.send(msg);
        });
    }
    sendAck(replyId, channel) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('MQTT Protocol not allow send ack');
        });
    }
    subscribe(originChannel, channel) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._channelAlias[originChannel] === undefined)
                this._channelAlias[originChannel] = {};
            if (this._channelAlias[originChannel][channel] === undefined)
                this._channelAlias[originChannel][channel] = 1;
            else
                this._channelAlias[originChannel][channel]++;
            console.log(this._channelAlias);
        });
    }
    unsubscribe(originChannel, channel) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._channelAlias[originChannel] === undefined)
                return console.log("Not current subscriptions, unsubscribe not allowed");
            if (this._channelAlias[originChannel][channel] === 1)
                delete this._channelAlias[originChannel];
            else
                this._channelAlias[originChannel][channel]--;
        });
    }
    toMessageWrapper(mqttMsg) {
        const ceMsg = JSON.parse(mqttMsg.payloadString);
        if (!ceMsg.subject) {
            console.error("Message not contain subject required attribute");
            return;
        }
        return new MessageWrapper(this, ceMsg);
    }
}
